import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fee0cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "menu-contents"
}
const _hoisted_3 = { class: "avatar" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Profile ")
const _hoisted_5 = { class: "links" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gem logs", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add friends", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Friend requests", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Log out", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleAvatar = _resolveComponent("CircleAvatar")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_van_col = _resolveComponent("van-col")!
  const _directive_click_away = _resolveDirective("click-away")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "menu-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, [
      _createElementVNode("img", { src: _ctx.HamburgerMenuIcon }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", {
      class: "menu",
      style: _normalizeStyle({ width: _ctx.menuWidth })
    }, [
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_CircleAvatar, {
                avatarUrl: _ctx.self.avatar,
                radius: 2.5,
                onClick: _ctx.goToProfile
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["avatarUrl", "radius", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_row, {
                tabindex: "1",
                onClick: _ctx.goToLogs
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_row, {
                tabindex: "2",
                onClick: _ctx.goToAddFriends
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_row, {
                tabindex: "3",
                onClick: _ctx.goToFriendRequests
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  (_ctx.requestCount > 0)
                    ? (_openBlock(), _createBlock(_component_van_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Notification, { requestCount: _ctx.requestCount }, null, 8, ["requestCount"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_row, {
                class: "log-out",
                tabindex: "4",
                onClick: _ctx.logOut
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 512)), [
    [_directive_click_away, _ctx.clickAway],
    [
      _directive_touch,
      _ctx.clickAway,
      "swipe",
      { left: true }
    ]
  ])
}